import HBModal from "@/components/HBModal";
import BoardPicker from "./index";
import styles from "./index.module.less";

export default function BoardPickerModal(props) {
  const { onCancel, onOk, defaultValue, ...rest } = props;
  const params = { onCancel, onOk, defaultValue };
  return (
    <HBModal
      footer={null}
      destroyOnClose
      {...rest}
      bodyStyle={{ padding: 0 }}
      width={480}
      onCancel={onCancel}
    >
      <div style={{ padding: "0 24px" }}>
        <div className={styles.modalTitle}>添加已有画板</div>
        <BoardPicker {...params} />
      </div>
    </HBModal>
  );
}
